"use client";

import { ArrowRight, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Sopralluogo() {
  const {
    ref: eyebrowRef,
    isVisible: eyebrowVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll<HTMLHeadingElement>();
  const {
    ref: subRef,
    isVisible: subVisible
  } = useRevealOnScroll<HTMLParagraphElement>();
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const tickerItems = ["HVAC", "UTA", "FILTRI", "VENTILATORI", "CAPPE", "HVAC", "UTA", "FILTRI", "VENTILATORI", "CAPPE"];
  return <section data-section-id="1269" id="pianifica-un-sopralluogo-tecnico" className="relative bg-background text-foreground overflow-hidden" style={{
    clipPath: "polygon(0 7%, 100% 0, 100% 100%, 0 100%)"
  }}>
      {}
      <div className="absolute z-10" style={{
      top: "calc(7% - 4px)",
      right: "0"
    }} aria-hidden="true">
        <div className="h-2 w-2 bg-[var(--primary)]" />
      </div>

      <div className="relative py-32 md:py-44 px-4 sm:px-8">
        {}
        <div ref={eyebrowRef} className={`max-w-[1100px] mx-auto mb-12 md:mb-16 flex items-center gap-3 transition-all duration-700 ease-out ${eyebrowVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <span className="block h-px w-6 bg-[var(--primary)]" />
          <span className="font-mono uppercase text-xs tracking-[0.18em] text-foreground/60" style={{
          letterSpacing: "0.18em"
        }}>
            TECHNICAL_SPECIALTY 
          </span>
        </div>

        {}
        <div className="relative max-w-[1100px] mx-auto">
          {}
          <div aria-hidden="true" className="pointer-events-none absolute inset-0 flex items-center justify-center opacity-[0.08] select-none">
            <span className="font-default leading-none text-foreground" style={{
            fontSize: "clamp(18rem, 36vw, 36rem)",
            lineHeight: 0.8,
            transform: "scale(0.6)",
            transformOrigin: "center"
          }}>
              <span className="hidden md:inline" style={{
              fontSize: "1rem"
            }}>
                {}
              </span>
              <span className="block">01</span>
            </span>
          </div>

          {}
          <h2 ref={headingRef} className={`relative font-default uppercase text-center mx-auto transition-all duration-700 ease-out backdrop-blur-sm bg-background/5 px-4 py-2 rounded-lg ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
          fontSize: "clamp(2.5rem, 6vw, 5.5rem)",
          fontWeight: 600,
          letterSpacing: "-0.005em",
          lineHeight: 0.92,
          color: "var(--secondary)"
        }}>
            IL{" "}
            <em className="not-italic" style={{
            color: "var(--primary)",
            fontStyle: "italic",
            display: "inline-block"
          }}>
              <span style={{
              fontStyle: "italic"
            }}>SOPRALLUOGO</span>
            </em>:{" "}
            UNA NECESSITÀ TECNICA PROFESSIONALE.
          </h2>

          {}
          <p ref={subRef} className={`relative mt-8 md:mt-10 text-center mx-auto max-w-2xl font-sans text-foreground transition-all duration-700 ease-out delay-100 backdrop-blur-sm bg-background/5 px-6 py-4 rounded-lg ${subVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
          fontSize: "clamp(1.0625rem, 1.2vw, 1.25rem)",
          lineHeight: 1.6
        }}>
            Richiedi una consulenza specialistica per la riqualificazione igienico-funzionale dei tuoi impianti. Analisi critica e piano operativo su misura.
          </p>

          {}
          <div ref={ctaRef} className={`relative mt-12 md:mt-16 flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-4 transition-all duration-700 ease-out delay-200 ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <Link to="/TechnicalInspectionPage" className="block w-full sm:w-auto">
              <Button className="group relative w-full sm:w-auto h-16 px-10 bg-[var(--primary)] text-white hover:bg-[var(--primary)]/90 uppercase font-default tracking-[0.05em] text-base overflow-hidden border border-white/20 shadow-lg rounded-lg transition-all duration-300">
                <span aria-hidden="true" className="absolute inset-y-0 -left-full w-full bg-white/10 transition-all duration-300 ease-out group-hover:left-0" style={{
                transform: "skewX(-7deg)"
              }} />
                <span className="relative flex items-center gap-3">
                  RICHIEDI SOPRALLUOGO
                  <ArrowRight className="size-5" />
                </span>
              </Button>
            </Link>

            <Link to="/TechnicalDivisionPage" className="block w-full sm:w-auto">
              <Button variant="outline" className="w-full sm:w-auto h-16 px-10 bg-transparent border-2 border-foreground text-foreground hover:bg-[var(--primary)] hover:text-[var(--primary-foreground)] hover:border-[var(--primary)] uppercase font-default tracking-[0.05em] text-base shadow-lg rounded-lg transition-all duration-300">
                <span className="flex items-center gap-3">
                  <Phone className="size-5" />
                  CONTATTA LA DIVISIONE
                </span>
              </Button>
            </Link>
          </div>
        </div>
      </div>

      {}
      <div className="relative border-t border-b border-foreground/15 py-6 overflow-hidden">
        <div className="flex whitespace-nowrap" style={{
        animation: "ticker-scroll 40s linear infinite"
      }}>
          {[...tickerItems, ...tickerItems].map((item, i) => <div key={i} data-index={i} className="flex items-center gap-8 px-8 font-default uppercase text-foreground" style={{
          fontSize: "clamp(1.5rem, 3vw, 2.5rem)",
          letterSpacing: "0.02em",
          lineHeight: 1
        }}>
              <span>{item}</span>
              <span className="text-[var(--primary)]">·</span>
            </div>)}
        </div>
        <style>{`
          @keyframes ticker-scroll {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
        `}</style>
      </div>
    </section>;
}